/* eslint-disable */
export default {
    sidebar_my_assessments: "Uitnodigingen",
    sidebar_welcome: "Welkom",
    sidebar_logout_could_not_logout: "Kon niet uitloggen",
    sidebar_logout_logout_text: "Log uit",
    sidebar_update_personal_details: "Persoonlijk profiel",
    sidebar_feature_toggles_menu_item: "Feature toggles",
    sidebar_reports_menu_item: "Rapporten"
};
